// ─── Shared types for the AutoChinBot Monitor ──────────────────

export interface AutoChinCtraderAccount {
  id: number;
  account_id: string;
  account_name: string;
}

export interface AutoChinSymbolEntry {
  symbolId: number;
  symbolName: string;
  digits: number;
  pipPosition?: number | null;
}

export interface AutoChinSymbolList {
  id: string;
  name: string;
  ctrader_account_id: string | null;
  symbols: AutoChinSymbolEntry[];
}

/** AutoChinBot works on the 1H timeframe (same as Chin Bot). */
export const AUTO_CHIN_TIMEFRAME = 'H1';

export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}